export default "__VITE_ASSET__113307f2__"